import React, { useContext } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AuthProvider from "../../context/AuthContext";
import { isEmpty } from "lodash";
import { useNavigate } from 'react-router-dom';

export const LinkCard = ({data}) => {
    const navigate = useNavigate();
    let { launchCasino, user } = useContext(AuthProvider);
  return (
    <a
        className={data.class}
        id={data.id}
        neua={data.title}
        onClick={() => {
        if (!isEmpty(user)) {

            launchCasino({
                platForm: data.platform,
                gameType: data.type,
                casinoType: data.gameCode,
                ...(data.isLobbyTrue ? { isLobbyTrue: true } : {})
            });
            
        } else {
            navigate("/login");
        }
        }}
        href="javascript:void(0)"
    >
        <dl className="entrance-title">
        <dt>{data.title}</dt>
        <dd> <span>Play Now</span></dd>
        </dl>
        <LazyLoadImage
        src={data.imgSrc }
        alt=""
        />
    </a>
  )
}
